/* WP-10 session context (§14.7): context object + hook live apart from the
 * provider component so session.tsx stays fast-refresh clean. */
import { createContext, useContext } from 'react';
import type { SessionResponse } from '../api/types';

export type SessionState =
  | { status: 'loading' }
  | { status: 'anonymous' }
  | { status: 'authed'; session: SessionResponse };

export type SessionContextValue = {
  state: SessionState;
  customer: SessionResponse['customer'] | null;
  /** True while the step-up window is still valid for sensitive mutations. */
  stepUpValid: boolean;
  refresh: () => Promise<void>;
  signOut: () => Promise<void>;
  signOutAll: () => Promise<void>;
  /** Seconds until absolute expiry; null when unknown/not authed. */
  expirySecondsLeft: number | null;
};

export const SessionContext = createContext<SessionContextValue>({
  state: { status: 'loading' },
  customer: null,
  stepUpValid: false,
  refresh: async () => {},
  signOut: async () => {},
  signOutAll: async () => {},
  expirySecondsLeft: null,
});

export function useSession(): SessionContextValue {
  return useContext(SessionContext);
}
